export default "__VITE_ASSET__6bfa71ed__"